export const PLAYBACK_STATE = {
  PLAYING: 'PLAYING',
  STARTING: 'STARTING',
  STOPPED: 'STOPPED',
};

export const ACTION_TYPE = {
  SET_PLAYBACK_STATE: 'SET_PLAYBACK_STATE',
  SET_VOLUME: 'SET_VOLUME',
  SET_MUTE: 'SET_MUTE',
  SET_ACTIVE_PROTOCOL: 'SET_ACTIVE_PROTOCOL',
};

export const initialState = {
  playbackState: PLAYBACK_STATE.STOPPED,
  volume: 0,
  muted: true,
  activeProtocol: null,
  retryCount: 0,
};

export default function reducer(state, action) {

  switch (action.type) {
    case ACTION_TYPE.SET_PLAYBACK_STATE: {
      return {
        ...state,
        playbackState: action.payload,
      };
    }
    case ACTION_TYPE.SET_VOLUME: {
      return {
        ...state,
        volume: Number(action.payload),
        muted: Number(action.payload) === 0,
      };
    }
    case ACTION_TYPE.SET_MUTE: {
      return {
        ...state,
        muted: !state.muted,
        volume: !state.muted ? 0 : 1,
      };
    }
    case ACTION_TYPE.SET_ACTIVE_PROTOCOL: {
      return {
        ...state,
        activeProtocol: action.payload,
      };
    }
    case ACTION_TYPE.RETRY: {
      return {
        ...state,
        retryCount: state.retryCount + 1,
      };
    }
    default:
      throw new Error('Action type is not recognized');
  }
}
